import MetaTags from "../../components/MetaTags";
import UserQuizResultsPage from "../../features/web/userProfile/userQuizResults/UserQuizResultsPage";

function UserQuizResults() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | نتائج الأختبارات"
                description="صفحة نتائج الأختبارات على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض نتائج الأختبارات لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <UserQuizResultsPage />;
        </>
    );
}

export default UserQuizResults;
